import StyledLink from '../StyledLink'
import makeQueryString from './makeUrl/makeUrl'
import {
  ASSETS,
  EDIT,
  MOVE,
  SPACES,
  SUITES
} from '../routes'

interface Params {
  importTo?: string
}

interface Props {
  children: React.ReactNode
  spaceId: string
  suiteId: string
}

const LinkToMoveSpaceAssetsInternalStorageSuites = ({
  children,
  spaceId,
  suiteId,
  ...params
}: Props & Params) => {
  const url = `/${SPACES}/${spaceId}/${ASSETS}/${EDIT}/${SUITES}/${suiteId}/${MOVE}`

  return (
    <StyledLink to={makeQueryString(url, { ...params })}>
      {children}
    </StyledLink>
  )
}

export default LinkToMoveSpaceAssetsInternalStorageSuites
